import { memo } from "react";
import PropTypes from "prop-types";
import List from "app/pages/.shared/List";
import { FormattedMessage } from "react-intl";
import InfoPopover from "app/components/ui/InfoPopover/InfoPopover";
import "./CouponsCGUPopoverButton.scss";

const CouponsCguPopoverButton = ({
	hasCredits,
	hasCreditInfos,
	hasCreditNotes,
	isPromotionCodeEnabled,
	isDetailed,
	onClick = () => {},
}) => {
	const handleOpenChange = isOpen => {
		if (isOpen) {
			onClick();
		}
	};

	return (
		<InfoPopover
			className="coupons-cgu-popover-button"
			onOpenChange={handleOpenChange}
			dataTestId="coupons-cgu-popover-icon"
			iconStyle={{ marginLeft: 8 }}
		>
			<div className="coupons-cgu-popover-button__content">
				{hasCredits && isPromotionCodeEnabled && (
					<div className="coupons-cgu-popover-button__item">
						<div className="coupons-cgu-popover-button__title">
							<FormattedMessage id="payment.coupons.cgu.general.title" />
						</div>
						<List
							items={[
								<FormattedMessage
									key="payment.coupons.cgu.general.1"
									id="payment.coupons.cgu.general.1"
								/>,
							]}
						/>
					</div>
				)}
				{hasCredits && (
					<div className="coupons-cgu-popover-button__item">
						<div className="coupons-cgu-popover-button__title">
							<FormattedMessage id="payment.coupons.cgu.credits.title" />
						</div>
						<List
							items={[
								<FormattedMessage
									id="payment.coupons.cgu.credits.1"
									key="payment.coupons.cgu.credits.1"
								/>,
								<FormattedMessage
									id="payment.coupons.cgu.credits.2"
									key="payment.coupons.cgu.credits.2"
								/>,
								<FormattedMessage
									id="payment.coupons.cgu.credits.3"
									key="payment.coupons.cgu.credits.3"
								/>,
								<FormattedMessage
									id="payment.coupons.cgu.credits.4"
									key="payment.coupons.cgu.credits.4"
								/>,
								<FormattedMessage
									id="payment.coupons.cgu.credits.5"
									key="payment.coupons.cgu.credits.5"
								/>,
							]}
						/>
					</div>
				)}
				{hasCreditInfos && (
					<div className="coupons-cgu-popover-button__item">
						<div className="coupons-cgu-popover-button__credit-title">
							<FormattedMessage id="mycoupons.credit.banner.info.title" />
						</div>
						<div className="coupons-cgu-popover-button__credit-item">
							<FormattedMessage id="mycoupons.credit.banner.info.description" />
						</div>
					</div>
				)}
				{hasCreditNotes && !isDetailed && (
					<div className="coupons-cgu-popover-button__item">
						<List
							items={[
								<FormattedMessage
									id="payment.coupons.cgu.refunds.1"
									key="payment.coupons.cgu.refunds.1"
								/>,
								<FormattedMessage
									id="payment.coupons.cgu.refunds.2"
									key="payment.coupons.cgu.refunds.2"
								/>,
								<FormattedMessage
									id="payment.coupons.cgu.refunds.3"
									key="payment.coupons.cgu.refunds.3"
								/>,
								<FormattedMessage
									id="payment.coupons.cgu.refunds.4"
									key="payment.coupons.cgu.refunds.4"
								/>,
								<FormattedMessage
									id="payment.coupons.cgu.refunds.5"
									key="payment.coupons.cgu.refunds.5"
								/>,
								<FormattedMessage
									id="payment.coupons.cgu.refunds.6"
									key="payment.coupons.cgu.refunds.6"
								/>,
							]}
						/>
					</div>
				)}
				{hasCreditNotes && isDetailed && (
					<div className="coupons-cgu-popover-button__item">
						<div className="coupons-cgu-popover-button__title">
							<FormattedMessage id="payment.coupons.cgu.refunds.banner.1" />
						</div>
					</div>
				)}
				{isPromotionCodeEnabled && (
					<div className="coupons-cgu-popover-button__item">
						<div className="coupons-cgu-popover-button__title">
							<FormattedMessage id="payment.coupons.cgu.promo.title" />
						</div>
						<List
							items={[
								<FormattedMessage
									id="payment.coupons.cgu.promo.1"
									key="payment.coupons.cgu.promo.1"
								/>,
								<FormattedMessage
									id="payment.coupons.cgu.promo.2"
									key="payment.coupons.cgu.promo.2"
								/>,
							]}
						/>
					</div>
				)}
			</div>
		</InfoPopover>
	);
};

CouponsCguPopoverButton.propTypes = {
	hasCredits: PropTypes.bool,
	hasCreditNotes: PropTypes.bool,
	isPromotionCodeEnabled: PropTypes.bool,
	isDetailed: PropTypes.bool,
	onClick: PropTypes.func,
	hasCreditInfos: PropTypes.bool,
};

export default memo(CouponsCguPopoverButton);
